import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { InteractionZone } from '@components/dnd/base/interaction';
import { useAtom } from '@hooks/useAtom';
import useStores from '@hooks/useStore';
import EndControlsFB from '@library/formBuilder/endControls';
import { FormLabel } from '@mui/joy';
import type { DNDBlock } from '@stratumn/studio-shared';
import { CircleSlash2, type LucideIcon } from 'lucide-react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

export const NotIcon: LucideIcon = CircleSlash2;

const Not = (dndBlock: DNDBlock) => {
  const dndPath = `${dndBlock.path}:not`;
  const notBlock: DNDBlock[] = dndBlock.props?.not || [];
  const transitionId = useParams()[ParamsList.TransitionId] as string;

  const { atomStore } = useStores();

  const notBlockAtom = useAtom({
    type: 'Not',
    sourceId: dndBlock.id,
    initialData: {},
    parentId: transitionId,
    parentKind: 'transition'
  });

  // Add reference between parent and child
  useEffect(() => {
    if (!notBlockAtom) {
      return;
    }
    notBlock.forEach(el => {
      if (el.atomId === dndBlock.atomId) {
        return;
      }

      const childAtom = atomStore.get(el.atomId);

      if (!childAtom) {
        return;
      }

      childAtom.addReferenceToAtom(notBlockAtom.id);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notBlockAtom, dndBlock, atomStore.get, notBlock.forEach]);

  if (!notBlockAtom) {
    return <></>;
  }

  return (
    <BlockBase
      dndBlock={dndBlock}
      endControls={
        <EndControlsFB
          dataItem={notBlockAtom}
          dndBlock={dndBlock}
          hasRequired={false}
        />
      }
      hasTitle={false}
      icon={NotIcon}
      isStatement
    >
      <Column>
        <FormLabel sx={{ fontSize: '12px' }}>Condition</FormLabel>
      </Column>
      <Column $width="100%">
        <InteractionZone dndBlock={notBlock} path={dndPath} />
      </Column>
    </BlockBase>
  );
};

export default observer(Not);
